export const loadScript = (src: string) => {
    const script = document.createElement('script');
    script.src = src;
    document.body.appendChild(script);
    return new Promise<any>((res, rej) => {
        script.onload = res;
        script.onerror = rej;
    });
}
